import React from "react";
import { Button } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import { Locale } from "../../../utils";
import { downloadCsv } from "../../../utils/statistics/exportCsv";

const i18n = Locale.getInstance();

export default function ExportCsvButton({ filename, columns, rows, disabled }) {
  const handleExport = () => {
    downloadCsv(filename, columns, rows || []);
  };

  return (
    <Button
      icon={<DownloadOutlined />}
      size="small"
      disabled={disabled || !rows || rows.length === 0}
      onClick={handleExport}
    >
      {i18n.t("statisticsCommon.exportCsv")}
    </Button>
  );
}
